import { render } from "./icon-x-dots.vue?vue&type=template&id=1f83c2ba"
import script from "./icon-x-dots.vue?vue&type=script&lang=js"
export * from "./icon-x-dots.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/packages/Computime/RidintaccVue/ridintacc-master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__